import logo from '../../../assets/images/logo.svg'

const Logo = () => {
  return (
    <a href='https://bit.ly/45UbviL' target='_blank' >
      <img src={logo} alt='jobify' className='logo' width={200} />
    </a>
  )
}

export default Logo